"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopifyEditor = exports.BaseComponent = void 0;
var base_component_1 = require("./base-component");
Object.defineProperty(exports, "BaseComponent", { enumerable: true, get: function () { return base_component_1.BaseComponent; } });
var editor_1 = require("./editor");
Object.defineProperty(exports, "ShopifyEditor", { enumerable: true, get: function () { return editor_1.ShopifyEditor; } });
